export const UNIT_CREDIT_PRICE = 0.12;

//  SUPPORTED CURRENCIES FOR RESELLER PLANS
export const currencyOptions = [
	{ value: 'usd', label: 'American Dollar (USD)', symbol: '$' },
	{ value: 'eur', label: 'Euro (EUR)', symbol: '€' },
	{ value: 'aud', label: 'Australian Dollar (AUD)', symbol: 'AUD' },
	{ value: 'gbp', label: 'British Pound (GBP)', symbol: '£' },
	{ value: 'cad', label: 'Canadian Dollar (CAD)', symbol: 'CAD' },
];
